import { CheckIcon, GlobeIcon } from "@radix-ui/react-icons";
import { Flex, Button, DropdownMenu, ChevronDownIcon } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

const langs = [
  { label: "English", value: "en" },
  { label: "Türkçe", value: "tr" },
];

export function LangSelector() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>
        <Button size="2" radius="full" color="gray" highContrast>
          <Flex align="center" gap="2">
            <GlobeIcon />
            {langs.find((item) => item.value === currentLang)?.label}
            <ChevronDownIcon />
          </Flex>
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content
        className="w-[110px] z-[99999]"
        variant="solid"
        highContrast
        color="gray"
        size="2"
      >
        {langs.map((lang) => (
          <DropdownMenu.Item
            key={lang.value}
            onClick={() => {
              i18n.changeLanguage(lang.value);
            }}
          >
            {currentLang === lang.value && <CheckIcon />}

            {lang.label}
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}
